<template>
  <v-container class="justify-center" container--fluid fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="8" lg="8" xl="8">
        <v-stepper
          v-model="st"
          class="ra-2"
          style="
            border-top: 5px solid #7f79d9;
            border-bottom: 5px solid #7f79d9;
            box-shadow: 0px 0px 27px 5px rgba(2, 2, 2, 0.096);
          "
        >
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card flat text class="pa-5 elevation-0">
                <div class>
                  <v-img
                    height="60"
                    contain
                    src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                    aspect-ratio="1"
                  ></v-img>
                </div>
                <v-card-title primary-title class="justify-space-around">
                  <span class="title primary--text d-block text-center font-weight-bold">{{
                    tipe == '2' ? 'Perpanjangan Masa Aktif' : 'Tambah Kuota Berlangganan'
                  }}</span>
                </v-card-title>
                <v-card-text>
                  <v-form data-vv-scope="form" lazy-validation>
                    <v-row column wrap>
                      <v-col cols="12" class="text-center">
                        <v-img
                          height="200"
                          contain
                          src="https://cdn.siap.id/s3/masook/asset%20img/SIM/aktv-pengguna.png"
                          aspect-ratio="1"
                        ></v-img>
                        <p class="justify-space-around black--text caption mb-0">
                          Silakan masukkan
                          <b>total kuota</b> yang akan Anda pesan beserta <b>surel aktif</b> untuk melanjutkan proses
                          berikutnya.
                        </p>
                      </v-col>
                      <v-col cols="12" class="pb-0 mb-0">
                        <m-alert show color="blue" title="Informasi" v-if="is_langganan">
                          <template v-slot:default>
                            <div class="caption">
                              Organisasi Anda saat ini berlangganan sejumlah
                              <strong> {{ current_organisasi.kuota }} Kuota Aktif </strong>
                              dari
                              <strong>{{ current_organisasi.jml_user }} Pengguna </strong>di instansi Anda Aktif
                              <strong>
                                berlaku hingga
                                {{ current_organisasi.tgl_berlaku_akhir | toDT }}
                                WIB
                              </strong>
                            </div>
                          </template>
                        </m-alert>
                      </v-col>
                      <v-col cols="12" v-if="tipe == 3">
                        <span>Pilih Periode Berlangganan</span>
                        <v-select
                          dense
                          single-line
                          outlined
                          :items="filterPeriode(itemOrders)"
                          name="Periode Berlangganan"
                          label="Periode Berlangganan"
                          v-model="order.periode"
                          hint="Pilih Periode Berlangganan"
                          data-vv-name="periode"
                          data-vv-as="periode"
                          return-object
                          v-validate="'required'"
                          item-text="start_at"
                          item-value="kuota_id"
                          :error-messages="errors.collect('form.periode')"
                        >
                          <template slot="selection" slot-scope="data">
                            <span class="mr-2"
                              >{{ data.item.start_at | toD }} s/d {{ data.item.expired_at | toD }}</span
                            >
                          </template>

                          <template slot="item" slot-scope="data">
                            <!-- HTML that describe how select should render items when the select is open -->
                            <span class="mr-2"
                              >{{ data.item.start_at | toD }} s/d {{ data.item.expired_at | toD }}</span
                            >
                            <m-chip
                              :title="data.item.is_aktif ? 'Periode Aktif' : 'Periode Perpanjangan'"
                              :color="data.item.is_aktif ? 'success' : 'warning'"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" class="pb-0">
                        <span>Jumlah Kuota</span>
                        <v-text-field
                          dense
                          outlined
                          persistent-hint
                          append-icon="mdi-plus"
                          @click:append="add()"
                          @click:prepend-inner="minus()"
                          prepend-inner-icon="mdi-minus"
                          class="centered-input"
                          v-model="order.jml_aktif"
                          data-vv-name="kuota"
                          data-vv-as="Kuota"
                          v-validate="tipe == 2 ? 'numeric' : 'numeric'"
                          :error-messages="errors.collect('form.kuota')"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          label="Surel"
                          placeholder="Surel"
                          dense
                          v-model="order.email"
                          hint="Pastikan surel yang diinputkan sudah benar dan valid. Agar dapat melakukan proses berlangganan dan Aktivasi"
                          data-vv-name="email"
                          v-validate="'required|email'"
                          :error-messages="errors.collect('form.email')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          label="Kode Voucher (opsional)"
                          placeholder="Masukan Kode Voucher"
                          dense
                          v-model="order.voucher"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <span>Menggunakan Faktur Pajak</span>
                        <v-radio-group
                          v-model="order.is_request_faktur"
                          row
                          dense
                          data-vv-name="faktur"
                          data-vv-as="Pilihan Faktur"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.faktur')"
                        >
                          <v-radio label="Ya" :value="1"></v-radio>
                          <v-radio label="Tidak" :value="0"></v-radio>
                        </v-radio-group>
                      </v-col>
                      <template v-if="order.is_request_faktur === 1">
                        <v-col cols="12" md="6" sm="12">
                          <div class="caption">Nomor NPWP</div>
                          <v-text-field
                            v-model="order.nomor_npwp"
                            dense
                            outlined
                            type="number"
                            placeholder="Nomor NPWP"
                            data-vv-name="nomor_npwp"
                            data-vv-as="Nomor NPWP"
                            v-validate="'required|numeric'"
                            :error-messages="errors.collect('form.nomor_npwp')"
                          />
                        </v-col>
                        <v-col cols="12" md="6" sm="12">
                          <div class="caption">Nama NPWP</div>
                          <v-text-field
                            v-model="order.nama_npwp"
                            dense
                            outlined
                            placeholder="Nama NPWP"
                            data-vv-name="nama_npwp"
                            data-vv-as="Nama NPWP"
                            v-validate="'required'"
                            :error-messages="errors.collect('form.nama_npwp')"
                          />
                        </v-col>
                        <v-col cols="12" md="12" sm="12">
                          <div class="caption">Alamat NPWP</div>
                          <v-textarea
                            v-model="order.alamat_npwp"
                            dense
                            outlined
                            placeholder="Isikan Alamat"
                            data-vv-name="alamat_npwp"
                            data-vv-as="Alamat NPWP"
                            v-validate="'required'"
                            :error-messages="errors.collect('form.alamat_npwp')"
                          />
                        </v-col>
                        <v-col cols="12" md="12" sm="12">
                          <MFileInput
                            ref="file"
                            v-model="order.file_npwp"
                            label="File NPWP"
                            :max="200"
                            :accept="['.jpg, .png']"
                            :required="true"
                            required-name="file_npwp"
                          />
                        </v-col>
                      </template>
                      <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                        <template v-if="order.is_request_faktur" class="py-0">
                          <v-checkbox v-model="is_konfirmasi_npwp">
                            <template v-slot:label>
                              <div class="caption">
                                Saya menyatakan NPWP dan nama pada kartu NPWP tertera jelas dan sama dengan saya input
                              </div>
                            </template>
                          </v-checkbox>
                          <v-checkbox v-model="is_konfirmasi_terbit">
                            <template v-slot:label>
                              <div class="caption">
                                Faktur pajak akan diterbitkan paling lambat 14 hari kerja setelah pembayaran, tidak
                                termasuk bila ada kendala-kendala pada Aplikasi Sistem Kantor Pajak Indonesia
                              </div>
                            </template>
                          </v-checkbox>
                        </template>
                        <v-checkbox v-model="konfirmasi">
                          <template v-slot:label>
                            <div class="caption">
                              Saya yakin surel yg saya inputkan sudah benar dan valid, untuk dapat menerima
                              pemberitahuan aktivasi dan melakukan proses pembayaran selanjutnya
                            </div>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12" class="justify-space-around text-center">
                        <m-button
                          is-block
                          :disabled="!allowNext"
                          class="ma-2"
                          text="Lanjutkan"
                          large
                          color="primary"
                          action="process"
                          @process="process"
                        ></m-button>
                        <m-button
                          outlined
                          is-block
                          class="ma-2 mt-4"
                          text="Kembali ke Halaman Utama"
                          large
                          action="close"
                          @close="$router.push({ name: 'billing' })"
                        ></m-button>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="text-center">
                        <v-layout justify-center align-center>
                          <v-flex shrink>
                            <div class="text-caption">didukung oleh</div>
                            <v-img
                              class="mx-auto"
                              src="https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/logo%20Finpay%20SAH%20(1).png"
                              width="100px"
                            />
                          </v-flex>
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <div class>
                <v-img
                  height="60"
                  contain
                  src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                  aspect-ratio="1"
                ></v-img>
              </div>
              <v-card flat text class="pa-5 elevation-0">
                <v-card-title primary-title class="justify-space-around">
                  <span class="title primary--text d-block text-center font-weight-bold">Konfirmasi Pesanan</span>
                </v-card-title>
                <v-card-text>
                  <v-row column wrap>
                    <v-col cols="12" class="text-center">
                      <p class="justify-space-around black--text caption mb-0">
                        Silakan periksa kembali data pesanan Anda berikut ini. Pastikan
                        <b>surel</b> yang akan Anda
                        <b>dapat kami hubungi.</b>
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <m-alert show color="blue" title="Informasi">
                        <template v-slot:default>
                          <div class="caption">
                            Organisasi Anda saat ini berlangganan sejumlah
                            <strong> {{ current_organisasi.kuota }} Kuota Aktif </strong>
                            dari
                            <strong>{{ current_organisasi.jml_user }} Pengguna </strong>di instansi Anda Aktif
                            <strong>
                              berlaku hingga
                              {{ current_organisasi.tgl_berlaku_akhir | toDT }}
                              WIB
                            </strong>
                          </div>
                        </template>
                      </m-alert>
                    </v-col>
                    <v-col cols="12" v-if="order.kuota">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td>Surel</td>
                              <td class="font-weight-bold">
                                {{ order.email }}
                              </td>
                            </tr>
                            <tr>
                              <td>Nama Instansi</td>
                              <td class="font-weight-bold">
                                {{ order.nama }}
                              </td>
                            </tr>
                            <tr>
                              <td>Jenis Pesanan</td>
                              <td class="font-weight-bold">
                                {{
                                  order.k_jenis_pesanan == 1
                                    ? 'Berlangganan Baru'
                                    : order.k_jenis_pesanan == 2
                                    ? 'Perpanjangan'
                                    : 'Tambah Kuota'
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Masa Berlaku</td>
                              <td class="font-weight-bold">
                                <span v-if="tipe == 3">
                                  {{ order.periode.start_at | toD }} s/d
                                  {{ order.periode.expired_at | toD }}
                                </span>
                                <span v-else>
                                  {{ periodePerpanjangan }}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>Total Kuota</td>
                              <td class="font-weight-bold">
                                {{ order.kuota }}
                              </td>
                            </tr>
                            <tr>
                              <td>Menggunakan Faktur Pajak</td>
                              <td class="font-weight-bold">
                                {{ order.is_request_faktur ? 'YA' : 'TIDAK' }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                    <v-col
                      v-if="detailOrder && detailOrder.voucher && detailOrder.voucher.pesan"
                      cols="12"
                      md="12"
                      sm="12"
                    >
                      <v-alert text type="error">
                        <div v-text="detailOrder.voucher.pesan" />
                      </v-alert>
                    </v-col>
                    <v-col cols="12" class="indigo lighten-5 ml-3" v-if="detailOrder.total">
                      <p>Rincian Pembayaran</p>
                      <v-row no-gutters>
                        <v-col cols="12" md="6">Layanan Masook</v-col>
                        <v-col cols="12" md="6">Rp {{ detailOrder.harga | toC }}</v-col>
                        <template
                          v-if="
                            detailOrder &&
                            detailOrder.voucher &&
                            detailOrder.voucher.harga &&
                            !detailOrder.voucher.pesan
                          "
                        >
                          <v-col cols="12" md="6">Voucher</v-col>
                          <v-col cols="12" md="6">- Rp {{ detailOrder.voucher.harga | toC }}</v-col>
                        </template>
                        <v-col cols="12" md="6">PPN 11%</v-col>
                        <v-col cols="12" md="6">Rp {{ detailOrder.ppn | toC }}</v-col>
                        <v-col cols="12" md="6">Admin Layanan</v-col>
                        <v-col cols="12" md="6">Rp {{ detailOrder.biaya_admin | toC }}</v-col>
                        <v-col cols="12" md="6" class="pt-4 font-weight-bold">Total Pembayaran</v-col>
                        <v-col cols="12" md="6" class="pt-4 font-weight-bold">Rp {{ detailOrder.total | toC }}</v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <p class="caption grey--text pt-3">
                    <i>* Biaya sudah termasuk biaya Pajak PPN 11%</i><br />
                    <template v-if="![1, 2].includes(Number(order.k_jenis_pesanan))">
                      * Proses tambah kuota kurang dari 30 hari, akan dihitung prorata. Yaitu dikenakan 200 rupiah
                      per-pengguna dikalikan jumlah sisa hari, hingga periode berjalan habis
                    </template>
                  </p>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                      <v-checkbox v-model="konfirmasiPesanan">
                        <template v-slot:label>
                          <div class="caption">
                            Saya yakin <strong>data pesanan</strong> diatas sudah sesuai dan surel yang saya gunakan
                            <strong>dapat dihubungi</strong> untuk proses selanjutnya
                          </div>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" class="justify-space-around text-center">
                      <m-button
                        is-block
                        :disabled="!konfirmasiPesanan"
                        class="ma-2"
                        text="Buat Pesanan"
                        large
                        color="primary"
                        action="onConfirm"
                        @onConfirm="onConfirm"
                      ></m-button>
                      <m-button
                        outlined
                        is-block
                        class="ma-2 mt-4"
                        text="Batal"
                        large
                        action="close"
                        @close="$router.push({ name: 'billing' })"
                      ></m-button>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" class="text-center">
                      <v-layout justify-center align-center>
                        <v-flex shrink>
                          <div class="text-caption">didukung oleh</div>
                          <v-img
                            class="mx-auto"
                            src="https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/logo%20Finpay%20SAH%20(1).png"
                            width="100px"
                          />
                        </v-flex>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask'
import moment from 'moment'
import Progress from '@/components/CompProgress'
import MFileInput from '@/components/MFileInput.vue'
export default {
  components: {
    Progress,
    MFileInput,
  },
  directives: {
    mask,
  },
  data() {
    return {
      st: 1,
      dialog: false,
      konfirmasi: null,
      konfirmasiPesanan: null,
      isAktif: false,
      isLangganan: false,
      loading: false,
      token: null,
      addOrder: true,
      tanggalAkhir: null,
      order: {
        id: 0,
        nama: '',
        jml_aktif: 10,
      },
      defOrder: {
        periode: null,
        jml_aktif: 10,
      },
      info: null,
      title: 'Masook',
      pesan: {},
      drawer: false,
      group: null,
      itemJenisPTK: [],
      detailOrder: {},
      itemOrders: [],
      is_konfirmasi_npwp: false,
      is_konfirmasi_terbit: false,
    }
  },
  mounted() {
    this.st = 1
    this.konfirmasi = null
    this.konfirmasiPesanan = null

    this.token = null
    this.itemJenisPTK = []
    this.order.organisasi_id = this.current_organisasi.organisasi_id
    this.order.nama = this.current_organisasi.nama
    this.order.data_id = this.current_organisasi.data_id
  },
  activated() {
    this.init()
    this.load()
  },
  computed: {
    allowNext() {
      if (this.order && this.order.is_request_faktur) {
        return this.konfirmasi && this.is_konfirmasi_npwp && this.is_konfirmasi_terbit
      } else {
        return this.konfirmasi
      }
    },

    tipe() {
      return this.$route.params.tipe
    },
    is_langganan() {
      if (this.$store.getters['main/berlangganan']) {
        return false
      } else {
        return true
      }
    },
    periodePerpanjangan() {
      var awal = moment(this.current_organisasi.tgl_berlaku_akhir, 'YYYY-MM-DD').add(1, 'days')

      var akhir = moment(this.current_organisasi.tgl_berlaku_akhir, 'YYYY-MM-DD').add(365, 'days')

      return this.$options.filters.toD(awal) + ' s/d ' + this.$options.filters.toD(akhir)
    },
  },

  methods: {
    init() {
      this.st = 1
      this.$validator.reset()
      this.konfirmasi = null
      this.konfirmasiPesanan = null
      this.defOrder.organisasi_id = this.current_organisasi.organisasi_id
      this.defOrder.nama = this.current_organisasi.nama
      this.defOrder.data_id = this.current_organisasi.data_id

      if (this.tipe == 2) {
        this.order = { ...this.defOrder }
        this.order.jml_aktif = this.current_organisasi.kuota
      } else {
        this.order = { ...this.defOrder }
      }
    },
    filterPeriode(data) {
      var orderAktif = data.filter((res) => res.is_aktif == 1 || res.is_delayed == 1)
      return orderAktif
    },
    load() {
      this.$store
        .dispatch('billing/get', {
          organisasi_id: this.organisasi_id,
        })
        .then((res) => {
          this.itemOrders = res.data
        })
        .catch((e) => e)
    },
    // eslint-disable-next-line
    process() {
      if (this.order && this.order.is_request_faktur) {
        this.$refs.file.validate();
      }
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          this.order.kuota = Number(this.order.jml_aktif)
          this.order.k_jenis_pesanan = this.tipe
          if (this.tipe == 3) {
            this.order.kuota_id = this.order.periode.kuota_id
          }
          this.cekHarga()
        })
        .then(() => {
          this.st = 2
        })
        .catch(() => {
          this.loading = false
        })
    },
    toURL(url) {
      window.open(url, '_self')
    },
    cekHarga() {
      let params = {
        data_id: this.order.data_id,
        organisasi_id: this.current_organisasi.organisasi_id,
        kuota: this.order.kuota,
        k_jenis_pesanan: this.order.k_jenis_pesanan,
        is_perpanjangan: this.order.periode && this.order.periode.is_delayed,
        voucher: (this.order && this.order.voucher ? this.order.voucher.replace(/[^\w\s]/gi, '') : '') || '',
        is_madrasah: this.is_simpatika ? 1 : 0
      }

      if (this.order && this.order.periode && this.order.periode.kuota_id) {
        this.$set(params, 'kuota_id', this.order.periode.kuota_id)
      }

      this.$store
        .dispatch("billing/cekHarga", params)
        .then(res => {
          this.detailOrder = res.data;
        })
        .catch((e) => e)
    },
    onConfirm() {
      this.$set(this.order, 'is_madrasah', this.is_simpatika ? 1 : 0)
      if (this.order && this.order.periode && this.order.periode.kuota_id) {
        this.$set(this.order, 'kuota_id', this.order.periode.kuota_id)
      }

      const formData = new FormData()

      Object.keys(this.order).forEach((key) => {
        if (![null, '', undefined].includes(this.order[key])) {
          formData.append(key, this.order[key])
        }
      })

      this.$store
        .dispatch('billing/order', formData)
        .then((res) => {
          this.$router.push({
            name: 'billing.pembayaran',
            params: {
              kode_pembayaran: res.data.kode,
            },
          })
        })
        .catch((e) => e)
    },
    add() {
      this.order.jml_aktif = this.order.jml_aktif + 1
    },
    minus() {
      if (this.order.jml_aktif !== 1) this.order.jml_aktif = this.order.jml_aktif - 1
    },
  },
}
</script>
<style lang="scss">
//.centered-input input {
//  text-align: center;
//  font-size: 2.5em;
//}

.background-1 {
  background-image: url('https://cdn.siap.id/s3/masook/asset%20img/portal/simpatika/bg-s1.png');
  background-size: cover;
}

.background-2 {
  background-image: url('https://cdn.siap.id/s3/masook/asset%20img/portal/simpatika/bg-s2.png');
  background-size: cover;
}
.green2 {
  background-color: rgb(228, 250, 234);
}
.v-card.on-hover {
  background-color: white !important;
  box-shadow: 0px 0px 27px 5px rgba(2, 2, 2, 0.034) !important;
}
.v-card.on-hover.theme--light.v-card > .v-card__text {
  /* color: white !important; */
}
.v-expansion-panel {
  /* box-shadow: white; */
}
.v-expansion-panel:before {
  box-shadow: none;
}
.centered-input input {
  text-align: center;
}
</style>
